// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flip-card {
  --flip-accent: var(--accent-navy);
  --flip-accent-soft: rgba(26, 54, 93, 0.12);
  --flip-back: var(--gradient-primary);
  perspective: 1200px;
  min-height: 260px;
  cursor: pointer;
  outline: none;
  transition: transform 0.35s ease;
}

.flip-card:hover {
  transform: translateY(-6px);
}

.flip-card.accent-navy {
  --flip-accent: #1a365d;
  --flip-accent-soft: rgba(26, 54, 93, 0.14);
  --flip-back: linear-gradient(145deg, #1a365d 0%, #2c5282 100%);
}

.flip-card.accent-gold {
  --flip-accent: #d4af37;
  --flip-accent-soft: rgba(212, 175, 55, 0.18);
  --flip-back: linear-gradient(145deg, #b8945f 0%, #d4af37 55%, #1a365d 100%);
}

.flip-card.accent-sky {
  --flip-accent: #38bdf8;
  --flip-accent-soft: rgba(56, 189, 248, 0.18);
  --flip-back: linear-gradient(145deg, #0e7490 0%, #2563eb 55%, #38bdf8 100%);
}

.flip-card.accent-teal {
  --flip-accent: #0d9488;
  --flip-accent-soft: rgba(13, 148, 136, 0.18);
  --flip-back: linear-gradient(145deg, #0f766e 0%, #0d9488 50%, #1a365d 100%);
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 260px;
  transition: transform 0.65s cubic-bezier(0.4, 0.2, 0.2, 1), filter 0.35s ease;
  transform-style: preserve-3d;
  filter: drop-shadow(0 14px 24px rgba(10, 37, 64, 0.16));
}

.flip-card:hover .flip-card-inner {
  filter: drop-shadow(0 22px 34px rgba(10, 37, 64, 0.24));
}

.flip-card.is-flipped .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-face {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  border-radius: 16px;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 8px 28px var(--shadow-color);
}

.flip-card-front {
  background:
    radial-gradient(circle at top right, var(--flip-accent-soft), transparent 55%),
    linear-gradient(145deg, var(--bg-white) 0%, var(--section-light-gray) 100%);
  border: 2px solid transparent;
  border-top: 4px solid var(--flip-accent);
}

.flip-card-back {
  background: var(--flip-back);
  color: #fff;
  transform: rotateY(180deg);
}

.flip-card.is-flipped .flip-card-face {
  box-shadow: 0 14px 36px rgba(212, 175, 55, 0.28);
}

.flip-card-icon {
  font-size: 2.75rem;
  margin-bottom: 1rem;
  animation: floatSoft 3.4s ease-in-out infinite;
}

.flip-card-front h3,
.flip-card-back h3 {
  font-size: 1.2rem;
  margin-bottom: 0.75rem;
  color: inherit;
}

.flip-card-front h3 {
  color: var(--primary-dark-blue);
}

.flip-card-front p,
.flip-card-back p {
  line-height: 1.7;
  font-size: 0.95rem;
  opacity: 0.92;
}

.flip-card-hint {
  margin-top: 1rem;
  font-size: 0.8rem;
  color: var(--footer-medium-gray);
  animation: pulseSoft 2.2s ease-in-out infinite;
}

.flip-card-link {
  margin-top: 1.25rem;
  display: inline-block;
  padding: 0.55rem 1.25rem;
  border-radius: 999px;
  background: #fff;
  color: var(--primary-dark-blue);
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.2s ease;
}

.flip-card-link:hover {
  transform: scale(1.04);
}

@media (max-width: 768px) {
  .flip-card:hover .flip-card-inner {
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .flip-card-icon,
  .flip-card-hint {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FlipCard.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,8DAA8D;AAChE;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6EAA6E;EAC7E,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;;+EAE6E;EAC7E,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".flip-card {\n  --flip-accent: var(--accent-navy);\n  --flip-accent-soft: rgba(26, 54, 93, 0.12);\n  --flip-back: var(--gradient-primary);\n  perspective: 1200px;\n  min-height: 260px;\n  cursor: pointer;\n  outline: none;\n  transition: transform 0.35s ease;\n}\n\n.flip-card:hover {\n  transform: translateY(-6px);\n}\n\n.flip-card.accent-navy {\n  --flip-accent: #1a365d;\n  --flip-accent-soft: rgba(26, 54, 93, 0.14);\n  --flip-back: linear-gradient(145deg, #1a365d 0%, #2c5282 100%);\n}\n\n.flip-card.accent-gold {\n  --flip-accent: #d4af37;\n  --flip-accent-soft: rgba(212, 175, 55, 0.18);\n  --flip-back: linear-gradient(145deg, #b8945f 0%, #d4af37 55%, #1a365d 100%);\n}\n\n.flip-card.accent-sky {\n  --flip-accent: #38bdf8;\n  --flip-accent-soft: rgba(56, 189, 248, 0.18);\n  --flip-back: linear-gradient(145deg, #0e7490 0%, #2563eb 55%, #38bdf8 100%);\n}\n\n.flip-card.accent-teal {\n  --flip-accent: #0d9488;\n  --flip-accent-soft: rgba(13, 148, 136, 0.18);\n  --flip-back: linear-gradient(145deg, #0f766e 0%, #0d9488 50%, #1a365d 100%);\n}\n\n.flip-card-inner {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 260px;\n  transition: transform 0.65s cubic-bezier(0.4, 0.2, 0.2, 1), filter 0.35s ease;\n  transform-style: preserve-3d;\n  filter: drop-shadow(0 14px 24px rgba(10, 37, 64, 0.16));\n}\n\n.flip-card:hover .flip-card-inner {\n  filter: drop-shadow(0 22px 34px rgba(10, 37, 64, 0.24));\n}\n\n.flip-card.is-flipped .flip-card-inner {\n  transform: rotateY(180deg);\n}\n\n.flip-card-face {\n  position: absolute;\n  inset: 0;\n  backface-visibility: hidden;\n  border-radius: 16px;\n  padding: 2rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  box-shadow: 0 8px 28px var(--shadow-color);\n}\n\n.flip-card-front {\n  background:\n    radial-gradient(circle at top right, var(--flip-accent-soft), transparent 55%),\n    linear-gradient(145deg, var(--bg-white) 0%, var(--section-light-gray) 100%);\n  border: 2px solid transparent;\n  border-top: 4px solid var(--flip-accent);\n}\n\n.flip-card-back {\n  background: var(--flip-back);\n  color: #fff;\n  transform: rotateY(180deg);\n}\n\n.flip-card.is-flipped .flip-card-face {\n  box-shadow: 0 14px 36px rgba(212, 175, 55, 0.28);\n}\n\n.flip-card-icon {\n  font-size: 2.75rem;\n  margin-bottom: 1rem;\n  animation: floatSoft 3.4s ease-in-out infinite;\n}\n\n.flip-card-front h3,\n.flip-card-back h3 {\n  font-size: 1.2rem;\n  margin-bottom: 0.75rem;\n  color: inherit;\n}\n\n.flip-card-front h3 {\n  color: var(--primary-dark-blue);\n}\n\n.flip-card-front p,\n.flip-card-back p {\n  line-height: 1.7;\n  font-size: 0.95rem;\n  opacity: 0.92;\n}\n\n.flip-card-hint {\n  margin-top: 1rem;\n  font-size: 0.8rem;\n  color: var(--footer-medium-gray);\n  animation: pulseSoft 2.2s ease-in-out infinite;\n}\n\n.flip-card-link {\n  margin-top: 1.25rem;\n  display: inline-block;\n  padding: 0.55rem 1.25rem;\n  border-radius: 999px;\n  background: #fff;\n  color: var(--primary-dark-blue);\n  font-weight: 700;\n  text-decoration: none;\n  transition: transform 0.2s ease;\n}\n\n.flip-card-link:hover {\n  transform: scale(1.04);\n}\n\n@media (max-width: 768px) {\n  .flip-card:hover .flip-card-inner {\n    transform: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .flip-card-icon,\n  .flip-card-hint {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
